import PaymentReminderLoadView from '@/pages/payment-reminder/set-reminder/PaymentReminderLoadView';
import EmailLogs from '@/pages/payment-reminder/email-logs/EmailLogs';
import UpdateEmail from '@/pages/payment-reminder/update-email/UpdateEmail';
import FileInfo from '@/pages/payment-reminder/set-reminder/FileInfo';

const paymentReminderRoutes = [
  { path: 'set-reminder', element: PaymentReminderLoadView },
  { path: 'set-reminder/fileInfo/:fileId', element: FileInfo },
  { path: 'email-logs', element: EmailLogs },
  { path: 'update-email', element: UpdateEmail },
];

export default paymentReminderRoutes;
